<template>
    <section class="promotion-page">
        <div class="promotion-shell">
            <header class="promotion-header">
                <div>
                    <p class="eyebrow">BUILDING LEADER PROMOTION</p>
                    <h1>楼长推广管理</h1>
                    <p>学校基础资料、楼长任职、邀请关系和推广海报统一管理。</p>
                </div>
                <el-tag type="info" effect="plain">后台菜单需配置 promotion:* 权限</el-tag>
            </header>

            <el-menu
                mode="horizontal"
                :default-active="activeTab"
                class="promotion-menu"
                @select="selectTab">
                <el-menu-item v-for="item in availableMenuItems" :key="item.key" :index="item.key">
                    {{ item.label }}
                </el-menu-item>
            </el-menu>

            <main class="promotion-content">
                <component v-if="availableMenuItems.length" :is="activeComponent" />
                <el-empty v-else description="当前账号没有楼长推广管理权限" />
            </main>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
import { PROMOTION_MENU } from "@/tool/promotionMenu";

export default {
    data() {
        return {
            activeTab: (this.$route.query && this.$route.query.tab) || "basics",
            menuItems: PROMOTION_MENU,
        };
    },
    computed: {
        ...mapState({
            basicData: (state) => state.user.basic_data || {},
        }),
        permissions() {
            return this.basicData.permissions || this.basicData.permissionList;
        },
        availableMenuItems() {
            if (!Array.isArray(this.permissions)) return this.menuItems;
            return this.menuItems.filter((item) => item.permissions.some((permission) => this.permissions.includes(permission)));
        },
        activeComponent() {
            const selectedKey = this.availableMenuItems.some((item) => item.key === this.activeTab)
                ? this.activeTab
                : this.availableMenuItems[0] && this.availableMenuItems[0].key;
            return {
                basics: () => import("./Basics"),
                leaders: () => import("./LeaderAppointments"),
                invitations: () => import("./Invitations"),
                posters: () => import("./PosterTemplates"),
            }[selectedKey] || (() => import("./Basics"));
        },
    },
    watch: {
        "$route.query.tab"(tab) {
            if (tab && this.menuItems.some((item) => item.key === tab)) this.activeTab = tab;
        },
    },
    methods: {
        selectTab(tab) {
            this.activeTab = tab;
            this.$router.replace({
                name: "promotion",
                query: { tab },
            });
        },
    },
};
</script>

<style scoped>
.promotion-page {
    min-height: calc(100vh - 160px);
    padding: 35px 0 60px;
    background:
        radial-gradient(circle at 90% 0, rgba(141, 154, 252, 0.13), transparent 25rem),
        #fbfaf8;
}

.promotion-shell {
    width: min(1220px, calc(100% - 40px));
    margin: 0 auto;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    box-shadow: 0 18px 55px rgba(33, 37, 56, 0.07);
}

.promotion-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 30px 34px 25px;
}

.eyebrow {
    margin: 0 0 8px;
    color: #8d9afc;
    font-size: 11px;
    letter-spacing: 0.16em;
}

h1 {
    margin: 0;
    color: #1e2432;
    font-size: 30px;
}

.promotion-header p:last-child {
    margin: 10px 0 0;
    color: #909399;
}

.promotion-menu {
    padding: 0 25px;
    border-top: 1px solid #f1f2f6;
    border-bottom: 1px solid #ebeef5;
}

.promotion-content {
    min-height: 620px;
    padding: 30px 34px 40px;
}

@media (max-width: 700px) {
    .promotion-shell {
        width: calc(100% - 20px);
    }

    .promotion-header {
        display: block;
        padding: 24px 20px 20px;
    }

    .promotion-header .el-tag {
        margin-top: 15px;
    }

    .promotion-menu {
        overflow-x: auto;
        padding: 0 10px;
        white-space: nowrap;
    }

    .promotion-content {
        padding: 22px 15px 30px;
    }
}
</style>
